import { FundOpportunityEOIController } from './controller';

const NO_INVESTOR_CONTEXT_MESSAGE = 'No investor context set';

export function submitEoi(
  ctx: FundOpportunityEOIController,
  investment: number,
  completedCallback?: () => void,
) {
  if (!ctx.props.investorContext) {
    console.error(NO_INVESTOR_CONTEXT_MESSAGE);
    return;
  }

  ctx.setState({ submittingEOI: true });
  ctx
    .getBackendService()
    .submitEoi(ctx.state.investor?.id as string, investment)
    .then(() => {
      ctx.setState({
        submittingEOI: false,
        updateEoi: false,
        withdrawEOI: false,
      });
      completedCallback?.();
      ctx.refreshInvestorPreservingScroll();
    });
}

export function commitEOIWithdrawal(
  ctx: FundOpportunityEOIController,
  completedCallback?: () => void,
) {
  if (!ctx.props.investorContext) {
    console.error(NO_INVESTOR_CONTEXT_MESSAGE);
    return;
  }

  ctx.setState({ withdrawingEOI: true });
  ctx
    .getBackendService()
    .withdrawEoi(ctx.state.investor?.id as string)
    .then(() => {
      completedCallback?.();
      ctx.refreshInvestorPreservingScroll();
    });
}

export function suggestEOI(
  ctx: FundOpportunityEOIController,
  investment: number,
  comment?: string,
  completedCallback?: () => void,
) {
  if (!ctx.props.investorContext) {
    console.error(NO_INVESTOR_CONTEXT_MESSAGE);
    return;
  }

  ctx.setState({ submittingEOI: true });
  ctx
    .getBackendService()
    .suggestEOI(ctx.state.investor?.id as string, investment, comment)
    .then(() => {
      ctx.setState({ submittingEOI: false });
      completedCallback?.();
      ctx.refreshInvestorPreservingScroll();
    })
    .catch((error) => {
      ctx.setState({ submittingEOI: false });
      console.error('Error suggesting EOI:', error);
      completedCallback?.();
    });
}

export function acceptSuggestedEOI(
  ctx: FundOpportunityEOIController,
  completedCallback?: () => void,
) {
  if (!ctx.props.investorContext) {
    console.error(NO_INVESTOR_CONTEXT_MESSAGE);
    return;
  }

  ctx.setState({ submittingEOI: true });
  ctx
    .getBackendService()
    .acceptSuggestedEOI(ctx.state.investor?.id as string)
    .then(() => {
      ctx.setState({ submittingEOI: false });
      completedCallback?.();
      ctx.refreshInvestorPreservingScroll();
    })
    .catch((error) => {
      ctx.setState({ submittingEOI: false });
      console.error('Error accepting suggested EOI:', error);
      completedCallback?.();
    });
}

export function rejectSuggestedEOI(
  ctx: FundOpportunityEOIController,
  completedCallback?: () => void,
) {
  if (!ctx.props.investorContext) {
    console.error(NO_INVESTOR_CONTEXT_MESSAGE);
    return;
  }

  ctx.setState({ submittingEOI: true });
  ctx
    .getBackendService()
    .rejectSuggestedEOI(ctx.state.investor?.id as string)
    .then(() => {
      ctx.setState({ submittingEOI: false });
      completedCallback?.();
      ctx.refreshInvestorPreservingScroll();
    })
    .catch((error) => {
      ctx.setState({ submittingEOI: false });
      console.error('Error rejecting suggested EOI:', error);
      completedCallback?.();
    });
}

export function withdrawSuggestedEOI(
  ctx: FundOpportunityEOIController,
  completedCallback?: () => void,
) {
  if (!ctx.props.investorContext) {
    console.error(NO_INVESTOR_CONTEXT_MESSAGE);
    return;
  }

  ctx.setState({ submittingEOI: true });
  (ctx.getBackendService() as any)
    .withdrawSuggestedEOI(ctx.state.investor?.id as string)
    .then(() => {
      ctx.setState({ submittingEOI: false });
      completedCallback?.();
      ctx.refreshInvestorPreservingScroll();
    })
    .catch(() => {
      completedCallback?.();
    });
}
